var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRemoveCircleIcon = function SvgRemoveCircleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99958 0.509277C13.9651 0.509277 17.9904 4.53459 17.9904 9.50007C17.9904 14.4655 13.9651 18.4909 8.99958 18.4909C4.0341 18.4909 0.00878906 14.4655 0.00878906 9.50007C0.00878906 4.53459 4.0341 0.509277 8.99958 0.509277ZM8.99958 1.75928C4.72446 1.75928 1.25879 5.22495 1.25879 9.50007C1.25879 13.7752 4.72446 17.2409 8.99958 17.2409C13.2747 17.2409 16.7404 13.7752 16.7404 9.50007C16.7404 5.22495 13.2747 1.75928 8.99958 1.75928ZM12.6129 10.09C12.9721 10.09 13.2633 9.79883 13.2633 9.43964C13.2633 9.08045 12.9721 8.78927 12.6129 8.78927H5.31019C4.951 8.78927 4.65982 9.08045 4.65982 9.43964C4.65982 9.79883 4.951 10.09 5.31019 10.09H12.6129Z",
    fill: "#CA4400"
  })));
};
export default SvgRemoveCircleIcon;